/* eslint-disable camelcase */
import { StepId } from '@/config/navigation.config'
import { Route } from 'next'

export type FormattedCalendarMeta = Record<string, Transformed.CalendarMeta>

export const AdmissionType = {
  TimedTicket: 'timed_ticket',
  DayPass: 'day_pass',
} as const

export type AdmissionTypeValues = typeof AdmissionType[keyof typeof AdmissionType]

export const AdmissionTypeDefault = AdmissionType.TimedTicket

/**
 * NOTE: typing here makes things nice for us, but probably won't play well if
 * they decide to add new payment methods on the fly.
 */
export const PaymentMethodType = {
  card: 'card',
  link: 'link',
  google_pay: 'google_pay',
  apple_pay: 'apple_pay',
  // TODO: remove afterpay clearpay after migrating to affirm
  afterpay_clearpay: 'afterpay_clearpay',
  affirm: 'affirm',
} as const

export type PaymentMethodTypeT = keyof typeof PaymentMethodType
/**
 * NOTE: this follows good relations definitions to a degree
 * Use what exists in the good relations ontology
 * make up what doesn't
 *
 * References:
 * https://schema.org/PaymentMethod
 * http://www.heppnetz.de/ontologies/goodrelations/v1#PaymentMethodCreditCard
 */
export const GoodRelationsPaymentMethod: { [key in keyof typeof PaymentMethodType]: string } = {
  card: 'http://purl.org/goodrelations/v1#PaymentMethodCreditCard',
  link: 'http://purl.org/goodrelations/v1#StripeLink',
  google_pay: 'http://purl.org/goodrelations/v1#GoogleCheckout',
  apple_pay: 'http://purl.org/goodrelations/v1#ApplePay',
  afterpay_clearpay: 'http://purl.org/goodrelations/v1#AfterPayClearPay',
  // TODO: confirm this is correct
  affirm: 'http://purl.org/goodrelations/v1#Affirm',
} as const

export const GoodRelationsPaymentMethodDefault = GoodRelationsPaymentMethod.card

export type InitialRouteAction =
  | { type: 'setStep', stepId: StepId }
  | { type: 'redirectTo', route: Route }
  | { type: 'reset' }
